import { Module } from 'vuex';

import { RootState } from '@/store';
import { UserTimer } from '@/services/user-timers/user-timers.types';
import { userTimersService } from '@/services/user-timers/user-timers.service';

export interface UserTimerState {
  userTimer: UserTimer;
  userTimerLoading: boolean;
}

const state: UserTimerState = {
  userTimer: null,
  userTimerLoading: false
};

const options: Module<UserTimerState, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    createUserTimer: ({ commit, dispatch }, userTimer: UserTimer): Promise<void> => {
      commit('userTimerLoading', true);
      return userTimersService
        .create(userTimer)
        .then(userTimer => commit('userTimer', userTimer))
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('userTimerLoading', false));
    },
    clearUserTimer({ commit }): void {
      commit('userTimer', null);
      commit('userTimerLoading', false);
    }
  },
  mutations: {
    userTimer: (state, userTimer: UserTimer) => (state.userTimer = userTimer),
    userTimerLoading: (state, userTimerLoading: boolean) => (state.userTimerLoading = userTimerLoading)
  }
};

export default options;
